class AccordionLinkTrigger extends HTMLElement {
  constructor() {
    super();
    this.target = document.querySelector(this.dataset.target);
  }
  connectedCallback() {
    this.addEventListener('click', () => {
      if (!this.target) return;

      const detailsElement =
        this.target.tagName === 'DETAILS'
          ? this.target
          : this.target.closest('details') || this.target.querySelector('details');

      if (detailsElement) detailsElement.open = true;

      this.target.scrollIntoView({
        behavior: 'smooth'
      });
    });
  }
}
customElements.define('accordion-link-trigger', AccordionLinkTrigger);